"use es6";

import { Fragment, useMemo, createElement } from 'react';
import { useHTMLProps } from "../html/use-props";
import { filterProps } from "./utils/filter-props";
import { isSVGComponent } from "./utils/is-svg-component";
import { useSVGProps } from "../svg/use-props";
import { isMotionValue } from "../../value/utils/is-motion-value";
function createUseRender(forwardMotionProps = false) {
  const useRender = (Component, props, ref, {
    latestValues
  }, isStatic) => {
    const useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== Fragment ? Object.assign({}, filteredProps, visualProps, {
      ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    const {
      children
    } = props;
    const renderedChildren = useMemo(() => isMotionValue(children) ? children.get() : children, [children]);
    return /*#__PURE__*/createElement(Component, Object.assign({}, elementProps, {
      children: renderedChildren
    }));
  };
  return useRender;
}
export { createUseRender };